import { collection, getDocs } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { db } from "../firebase";

const styles = {
  screen: { minHeight: "100vh", backgroundColor: "#F4F6F9", fontFamily: "system-ui, sans-serif" },
  main: { marginLeft: 220, padding: 24 },
  title: { fontSize: 22, fontWeight: "700", color: "#0A2D5A", marginBottom: 4 },
  sub: { fontSize: 13, color: "#888", marginBottom: 24 },
  card: { backgroundColor: "white", borderRadius: 12, border: "0.5px solid #e0e0e0", padding: 24, maxWidth: 640 },
  label: { display: "block", fontSize: 13, fontWeight: "600", color: "#444", marginBottom: 6, marginTop: 16 },
  input: { width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 15, boxSizing: "border-box", outline: "none" },
  textarea: { width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 15, boxSizing: "border-box", outline: "none", minHeight: 140, resize: "vertical", fontFamily: "system-ui, sans-serif" },
  radioRow: { display: "flex", gap: 20, marginTop: 8 },
  radioLabel: { display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#333", cursor: "pointer" },
  agentList: { border: "1px solid #eee", borderRadius: 8, marginTop: 12, maxHeight: 240, overflowY: "auto" },
  agentRow: { display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", borderBottom: "0.5px solid #f2f2f2", fontSize: 14, cursor: "pointer" },
  saveBtn: { marginTop: 20, backgroundColor: "#E8620A", color: "white", border: "none", borderRadius: 8, padding: "12px 24px", fontSize: 15, fontWeight: "600", cursor: "pointer" },
  toast: { position: "fixed", bottom: 32, left: "50%", transform: "translateX(-50%)", backgroundColor: "#0A2D5A", color: "white", padding: "12px 24px", borderRadius: 10, fontSize: 14, fontWeight: "600", zIndex: 2000 },
  count: { fontSize: 12, color: "#888", marginTop: 6 },
};

export default function AdminMessage() {
  const [agents, setAgents] = useState([]);
  const [target, setTarget] = useState("all");
  const [selected, setSelected] = useState({});
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDocs(collection(db, "agents"));
        setAgents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error("load agents", e); }
    };
    load();
  }, []);

  const toggle = (id) => setSelected((prev) => { const n = Object.assign({}, prev); n[id] = !n[id]; return n; });

  const selectedIds = agents.filter((a) => selected[a.id]).map((a) => a.id);
  const recipientCount = target === "all" ? agents.length : selectedIds.length;

  const send = async () => {
    if (!subject.trim() || !body.trim()) { setToast("Subject and message are required."); setTimeout(() => setToast(null), 3000); return; }
    if (target === "selected" && selectedIds.length === 0) { setToast("Select at least one agent."); setTimeout(() => setToast(null), 3000); return; }
    setSending(true);
    try {
      const fns = getFunctions();
      const call = httpsCallable(fns, "adminSendAgentMessage");
      const res = await call({ subject: subject, body: body, target: target, agentIds: selectedIds });
      const n = res.data && res.data.sent ? res.data.sent : 0;
      setToast("Message sent to " + n + " agent" + (n === 1 ? "" : "s") + ".");
      setSubject(""); setBody(""); setSelected({}); setTarget("all");
    } catch (e) {
      console.error("send message", e);
      setToast("Send failed.");
    }
    setSending(false);
    setTimeout(() => setToast(null), 4000);
  };

  return (
    <div style={styles.screen}>
      <Sidebar admin />
      <div style={styles.main}>
        {toast ? <div style={styles.toast}>{toast}</div> : null}
        <div style={styles.title}>Send Message to Agents</div>
        <div style={styles.sub}>Email an announcement or update to your agents.</div>

        <div style={styles.card}>
          <label style={styles.label}>Recipients</label>
          <div style={styles.radioRow}>
            <label style={styles.radioLabel}>
              <input type="radio" name="target" checked={target === "all"} onChange={() => setTarget("all")} />
              All agents
            </label>
            <label style={styles.radioLabel}>
              <input type="radio" name="target" checked={target === "selected"} onChange={() => setTarget("selected")} />
              Select specific agents
            </label>
          </div>

          {target === "selected" ? (
            <div style={styles.agentList}>
              {agents.map((a) => (
                <label key={a.id} style={styles.agentRow}>
                  <input type="checkbox" checked={!!selected[a.id]} onChange={() => toggle(a.id)} />
                  <span style={{ fontWeight: 600 }}>{a.name || "(no name)"}</span>
                  <span style={{ color: "#888" }}>{a.email}</span>
                </label>
              ))}
            </div>
          ) : null}

          <label style={styles.label}>Subject</label>
          <input style={styles.input} value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="e.g. New feature update" />

          <label style={styles.label}>Message</label>
          <textarea style={styles.textarea} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Write your message to agents..." />

          <div style={styles.count}>Will send to {recipientCount} agent{recipientCount === 1 ? "" : "s"}.</div>

          <button style={styles.saveBtn} onClick={send} disabled={sending}>
            {sending ? "Sending..." : "Send Message"}
          </button>
        </div>
      </div>
    </div>
  );
}
